import React from 'react';

import { Loader, Message } from '@components';
import { RequestStatus } from '@store/types/request';

interface IHOCLoader {
  status: RequestStatus;
  isEmpty: boolean;
  customEmpty?: any;
  customError?: any;
}

/**
 * defines (hoc) loader component which handles common states for async components
 * @param {number} status - status of the ajax request uses - @enum {RequestStatus}
 * @param {boolean} isEmpty - if the request data is empty or not.
 */
export const HOCLoader: React.FC<IHOCLoader> = ({
  status,
  isEmpty,
  customEmpty,
  customError,
  children: componentContent,
}) => {
  // AJAX Request Initialization || Loading
  if (status === 0 || status === 1) return <Loader />;
  // AJAX Request Success - Results Full
  if (status === 2 && !isEmpty) return <>{componentContent}</>;
  // AJAX Request Success - Results Empty
  if (status === 2 && isEmpty) {
    // if custom empty message
    if (customEmpty) return <>{customEmpty}</>;
    // else default to the default empty message
    return <Message type='empty' />;
  }
  // AJAX Request Failure
  if (status === 3)
    if (customError)
      // if custom error message
      return <>{customError}</>;
  // else default to the default error message
  return <Message type='error' />;
};
